import type { CustomerId } from '@gh/common/models'

/** Must stay in sync with `usePaymentMethodStore` throttle keys. */
export const PAYMENT_METHOD_RECALC_THROTTLE_KEY_PREFIX = 'paymentMethodRecalcLastTriggeredAt:'

/**
 * Removes localStorage entries that embed the signed-out customer's id.
 * Does not touch `signup-session` (anonymous signup flow).
 */
export function removeCustomerScopedLocalStorage(customerId: CustomerId | undefined): void {
  if (!customerId || typeof localStorage === 'undefined') {
    return
  }
  try {
    localStorage.removeItem(`${PAYMENT_METHOD_RECALC_THROTTLE_KEY_PREFIX}${customerId}`)
  } catch {
    // ignore quota / private mode
  }
}
